import Icon from "@material-ui/icons/Autorenew";
import ChangeRequestList from "./ChangeRequestList";
import ChangeRequestCreate from "./ChangeRequestCreate";
import ChangeRequestEdit from "./ChangeRequestEdit";
import ChangeRequestShow from "./ChangeRequestShow";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "changeRequestForms",
  create: ChangeRequestCreate,
  list: ChangeRequestList,
  show: ChangeRequestShow,
  edit: ChangeRequestEdit,
  icon: Icon,
};
